// import from react
import React, { PropsWithChildren } from 'react';
import {
  StyledDrawerFooterInnerBox,
  StyledDrawerFooterMainBox
} from './DrawerFooter.styles';

const DrawerFooter: React.FC<PropsWithChildren<object>> = ({ children }) => {
  return (
    <StyledDrawerFooterMainBox>
      <StyledDrawerFooterInnerBox>{children}</StyledDrawerFooterInnerBox>
    </StyledDrawerFooterMainBox>
  );
};

export default DrawerFooter;
